export default __webpack_public_path__ + "static/media/29.fe787cf6.jpg";